export default __webpack_public_path__ + "static/media/cropped-navbar-header-1.04efe5db.png";